<app-step-progress-nav
	[steps]="steps"
	[current]="currentStep"
	textSize="small"
	class="mt-5"
></app-step-progress-nav>
